import axios from "axios";

window.addEventListener("DOMContentLoaded", () => {
	let sgo_grid = document.querySelector(".sgos_grid");
	let loading = document.querySelector(".sgos_grid .loading");
	let first_label = document.querySelector(".featured_sgo .featured_navigation span.world");
	let labels = document.querySelectorAll(".featured_sgo .featured_navigation span");
	if (labels) {
		labels.forEach((el) => {
			el.addEventListener("click", () => {
				let current_label = document.querySelector(".featured_sgo .featured_navigation span.current");
				if (current_label) {
					current_label.classList.remove("current");
				}
				el.classList.add("current");
				filter(el.dataset.filter);
			});
		});
	}
	if (sgo_grid && first_label) {
		let form_data = new FormData();
		form_data.append("action", "get_featured_sgos");
		axios.post(ajaxurl, form_data)
			.then((data) => {
				loading.classList.add("hidden");
				data.data.forEach((el) => {
					let classes = "sgo";
					if (el.locations) {
						el.locations.forEach((item) => {
							classes += ` ${item.slug}`;
						});
					} else {
						classes += ` world`;
					}
					let element = `<a class="world ${classes}" href="${el.permalink}" title="${el.name} on thedotgood.">
                                     <img class="featured" title="${el.name}" alt="${el.name} on the dot good" loading="lazy" src="${el.featured}" />
                                     <div class="bottom">
                                          <h2>${el.name}</h2>
                                          <h3>${el.slogan || ""}</h3>
                                          <div class="more"><i class="far fa-angle-right"></i></div>
                                     </div>
                              `;
					sgo_grid.innerHTML += element;
					first_label.click();
				});
			})
			.catch((err) => {
				console.log(err);
			});
	}

	const filter = (term) => {
		let featured = document.querySelectorAll(".sgos_grid .sgo");
		if (featured) {
			featured.forEach((el) => {
				if (el.classList.contains(term)) {
					el.classList.remove("hidden");
				} else {
					el.classList.add("hidden");
				}
			});
		}
	};
});
